<template>
  <el-dialog :title="$t('addBusinessTableHis.addBusinessTrack')" :visible.sync="dialogVisible" width="50%">
    <el-form :model="addBusinessTableHisInfo" :rules="rules" ref="form" label-width="120px">
      <el-form-item :label="$t('addBusinessTableHis.businessType')" prop="businessTypeCd">
        <el-input v-model="addBusinessTableHisInfo.businessTypeCd"
          :placeholder="$t('addBusinessTableHis.requiredBusinessType')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('addBusinessTableHis.action')" prop="action">
        <el-select v-model="addBusinessTableHisInfo.action" :placeholder="$t('addBusinessTableHis.requiredAction')"
          style="width:100%">
          <el-option :label="$t('addBusinessTableHis.pleaseSelect')" value="" disabled></el-option>
          <el-option label="ADD" value="ADD"></el-option>
          <el-option label="MOD" value="MOD"></el-option>
          <el-option label="DEL" value="DEL"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addBusinessTableHis.tableName')" prop="actionObj">
        <el-input v-model="addBusinessTableHisInfo.actionObj"
          :placeholder="$t('addBusinessTableHis.requiredTableName')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('addBusinessTableHis.trackTableName')" prop="actionObjHis">
        <el-input v-model="addBusinessTableHisInfo.actionObjHis"
          :placeholder="$t('addBusinessTableHis.requiredTrackTableName')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('addBusinessTableHis.remark')">
        <el-input v-model="addBusinessTableHisInfo.remark" :placeholder="$t('addBusinessTableHis.optionalRemark')"
          type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveBusinessTableHisInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveBusinessTableHis } from '@/api/dev/businessTableHisApi'

export default {
  name: 'AddBusinessTableHis',
  data() {
    return {
      dialogVisible: false,
      addBusinessTableHisInfo: {
        businessTypeCd: '',
        action: '',
        actionObj: '',
        actionObjHis: '',
        remark: ''
      },
      rules: {
        businessTypeCd: [
          { required: true, message: this.$t('addBusinessTableHis.requiredBusinessType'), trigger: 'blur' },
          { max: 30, message: this.$t('addBusinessTableHis.max30Chars'), trigger: 'blur' }
        ],
        action: [
          { required: true, message: this.$t('addBusinessTableHis.requiredAction'), trigger: 'change' }
        ],
        actionObj: [
          { required: true, message: this.$t('addBusinessTableHis.requiredTableName'), trigger: 'blur' },
          { max: 64, message: this.$t('addBusinessTableHis.max64Chars'), trigger: 'blur' }
        ],
        actionObjHis: [
          { required: true, message: this.$t('addBusinessTableHis.requiredTrackTableName'), trigger: 'blur' },
          { max: 64, message: this.$t('addBusinessTableHis.max64Chars'), trigger: 'blur' }
        ],
        remark: [
          { max: 200, message: this.$t('addBusinessTableHis.max200Chars'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.resetForm()
    },
    resetForm() {
      this.addBusinessTableHisInfo = {
        businessTypeCd: '',
        action: '',
        actionObj: '',
        actionObjHis: '',
        remark: ''
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
      })
    },
    saveBusinessTableHisInfo() {
      this.$refs.form.validate(async valid => {
        if (!valid) return

        try {
          await saveBusinessTableHis(this.addBusinessTableHisInfo)
          this.$message.success(this.$t('addBusinessTableHis.addSuccess'))
          this.dialogVisible = false
          this.$emit('success')
        } catch (error) {
          console.error('添加业务轨迹失败:', error)
        }
      })
    }
  }
}
</script>